import type React from "react"
import { NavLink } from "react-router-dom"
import { RiAddLine } from "react-icons/ri"
import "./RegisterPlaceButton.css"

type RegisterPlaceButtonProps = {
  className?: string
}

const RegisterPlaceButton: React.FC<RegisterPlaceButtonProps> = ({
  className,
}) => {
  return (
    <NavLink
      to="/site/register"
      className={`register-place-button-style ${className || ""}`}
    >
      <span className="register-place-icon-wrapper">
        <RiAddLine />
      </span>
      <span className="register-place-text">장소 등록하기</span>
    </NavLink>
  )
}

export default RegisterPlaceButton
